import React, { Component } from 'react';
import classNames from 'classnames';
import constants from '../../constants';
import { withPage } from '../util';
import LinkIcon from '../link-icon';
import './header.css';

class Header extends Component {
  render() {
    const { SCHEDULE, CREATE, SETTINGS, PREVIOUS } = constants.pages;
    const { page } = this.props;
    const links = {
      [SCHEDULE]: {
        name: 'delete',
        page: CREATE
      },
      [CREATE]: {
        name: 'calendar',
        page: SCHEDULE
      },
      [SETTINGS]: {
        name: 'delete',
        page: CREATE
      }
    };
    return (
      <div>
        <div className={classNames('header', page === SCHEDULE && 'fixed')}>
          <div className="title">
            Wilshire Grand
          </div>
          <LinkIcon lineHeight="50px" {...links[page]} />
          {page === CREATE &&
            <LinkIcon lineHeight="50px" name="sign out" page={SETTINGS} />}
        </div>
        {page === SCHEDULE && <div className="ghost-header" />}
      </div>
    );
  }
}

export default withPage(Header);



// WEBPACK FOOTER //
// ./src/components/header/index.js